import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LinkIcon, VideoCameraIcon } from "@heroicons/react/24/outline";

export default function Updatesandinfo() {
  const [updatesandinfo, setUpdatesandinfoRoutes] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogContent, setDialogContent] = useState(null);
  const [page, setPage] = useState(1);
  const itemsPerPage = 6;

useEffect(() => {
    const updatesandinfo = [
      {
        _id: "1",
        title: "",
        description: "",
        link: "",
        file: "", 
	createdAt: new Date(),
      },
    ];

    setUpdatesandinfoRoutes(updatesandinfo);
  }, []);

  // Utility functions to check file type
  const isImageFile = (file) => /\.(jpeg|jpg|gif|png)$/i.test(file);
  const isVideoFile = (file) => /\.(mp4|mov|wmv|avi|mkv)$/i.test(file);

  // Dialog handlers
  const handleOpenDialog = (content) => {
    setDialogContent(content);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDialogContent(null);
  };

  // Pagination logic
  const totalPages = Math.ceil(updatesandinfo?.length / itemsPerPage);
  const getVisibleUpdatesandinfo = () => {
    const startIndex = (page - 1) * itemsPerPage;
    return updatesandinfo?.slice(startIndex, startIndex + itemsPerPage);
  };

  const handleNextPage = () =>
    setPage((prev) => Math.min(prev + 1, totalPages));
  const handlePreviousPage = () => setPage((prev) => Math.max(prev - 1, 1));

  return (
    <div className="flex flex-col items-center p-8 sm:p-10 lg:p-12 pb-16">
      {/* Title */}
      <h1 className="text-3xl font-bold text-center mb-8">News and updates</h1>

      {/* Blog Cards */}
      <div className="w-full flex flex-wrap justify-center gap-6">
        {getVisibleUpdatesandinfo()?.map((info) => (
          <div
            key={info.id}
            className="w-full sm:w-11/12 md:w-5/12 lg:w-1/4 bg-white shadow-lg rounded-lg p-6 mb-8 flex flex-col justify-between"
          >
            {info?.file && isImageFile(info.file) && (
              <img
                src={info.file}
                alt={info.title}
                className="w-full h-40 object-cover shadow-lg mt-1 cursor-pointer mb-4"
                onClick={() => handleOpenDialog(info.file)}
              />
            )}
            {info?.file && isVideoFile(info.file) && (
              <div
                className="relative w-full h-40 bg-black cursor-pointer shadow-lg mt-1 mb-4"
                onClick={() => handleOpenDialog(info.file)}
              >
                <VideoCameraIcon className="absolute inset-0 m-auto text-white h-12 w-12" />
              </div>
            )}
            <div className="text-left">
              <h3 className="text-lg font-bold mb-2">{info?.title}</h3>
              <p className="text-sm text-gray-600 mb-2">
                {info?.description?.length > 35 ? (
                  <>
                    {info.description.slice(0, 35)}...
                    <button
                      onClick={() => handleOpenDialog(info.description)}
                      className="text-blue-500 hover:underline ml-1"
                    >
                      Read more
                    </button>
                  </>
                ) : (
                  info.description
                )}
              </p>
            </div>
		{/*<div className="flex justify-start mt-4">
              <button
                className={`bg-[#3FD0A2] text-white font-bold py-2 px-4 rounded-full text-xs sm:text-sm flex items-center gap-2 ${
                  !info?.link ? "opacity-50 cursor-not-allowed" : ""
                }`}
                onClick={() => info?.link && window.open(info.link, "_blank")}
                disabled={!info?.link}
              >
                <LinkIcon className="h-5 w-5" />
                {info?.link ? "Read more" : "No Link Available"}
              </button>
            </div>*/ }
            <div className="border-t border-gray-300 mt-4 pt-2">
              <p className="text-xs text-gray-500">
                {new Date(info?.createdAt).toLocaleDateString()}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="flex justify-center items-center mt-8">
        <button
          onClick={handlePreviousPage}
          disabled={page === 1}
          className="text-blue-500 hover:text-blue-700 text-lg px-4"
        >
          « Previous
        </button>
        <span className="mx-4 text-gray-600">
          Page {page} of {totalPages}
        </span>
        <button
          onClick={handleNextPage}
          disabled={page === totalPages}
          className="text-red-500 hover:text-red-700 text-lg px-4"
        >
          Next »
        </button>
      </div>

      {/* Dialog for media and description preview */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogActions>
          <IconButton onClick={handleCloseDialog}>
            <CloseIcon />
          </IconButton>
        </DialogActions>
        <DialogContent>
          {dialogContent && (isImageFile(dialogContent) || isVideoFile(dialogContent)) ? (
            <>
              {isImageFile(dialogContent) && (
                <img src={dialogContent} alt="Preview" className="w-full h-auto" />
              )}
              {isVideoFile(dialogContent) && (
                <video controls className="w-full h-auto">
                  <source src={dialogContent} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
            </>
          ) : (
            <p className="text-gray-700">{dialogContent}</p>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
